export const UX_COPY_ID = {
  "quickNavAria": "Navigasi cepat ke setiap bagian",
  "skipToSections": "Lewati ke navigasi bagian",
  "jumpToStudioHint": "Pintasan: Alt + S"
};

export const TRIAL_FLOW_COPY_ID = {
  "flowLabel": "Langkah berikutnya",
  "flowSteps": [
    "Pilih satu gambar untuk uji coba singkat.",
    "Metadata Studio akan terbuka dengan marketplace stok pilihan Anda.",
    "Tinjau dan edit hasilnya sebelum mengekspor."
  ]
};

export const LANDING_SALES_COPY_ID = {};


export default LANDING_SALES_COPY_ID;
